import { axios } from 'lib'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { Response } from 'services/api/types'

type AutentiqueLink = {
  link: string
}

const createOrderAutentiqueLink = (data: any): Response<AutentiqueLink> => {
  return axios.post(`/autentique/send-document`, data)
}

export function useCreateOrderAutentiqueLink() {
  const queryClient = useQueryClient()
  return useMutation(createOrderAutentiqueLink, {
    onSuccess: () => {
      queryClient.invalidateQueries('orders')
      queryClient.invalidateQueries('orderActions')
      queryClient.invalidateQueries('loadAutentiqueSignedProposals')
      queryClient.invalidateQueries('loadHandSignedProposals')
    },
    onError: (error: any) => {
      let errorMsg = 'Não foi possível carregar o link do Autentique!'
      if (error?.response?.data?.message)
        errorMsg = error?.response?.data?.message
      toast.error(errorMsg)
    }
  })
}
